module.exports = __webpack_public_path__ + "img/roast.b423c182.jpg";